import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import SignUpCnn from '../Auth/connected/SignUpCnn';


type PropsType = RouteComponentProps<any>

class SignUpView extends Component<PropsType> {
    render() {
        return (
                <div className="register-container">
                    <SignUpCnn />
                </div>
        );
    }
}

export default withRouter(SignUpView);